<template>
  <v-layout row wrap v-if="hasPermission('superuser')">
    <v-flex xs6>
      {{ accountSelected.name }}
      <v-tooltip bottom content-class="overline">
        <v-icon slot="activator" small>
          fa-info-circle
        </v-icon>
        <VueJsonPrettyWrapper :data="accountSelected"></VueJsonPrettyWrapper>
      </v-tooltip>
    </v-flex>
    <v-flex xs6>
      {{ terminal.name }}
      <v-tooltip bottom content-class="overline">
        <v-icon slot="activator" small>
          fa-info-circle
        </v-icon>
        <VueJsonPrettyWrapper :data="terminal"></VueJsonPrettyWrapper>
      </v-tooltip>
    </v-flex>
  </v-layout>
</template>

<script>
import VueJsonPrettyWrapper from '@/components/VueJsonPrettyWrapper.vue'
import AuthMixin from '@/mixins/auth'
import StoreMixin from '@/store/mixin'

export default {
  mixins: [AuthMixin, StoreMixin],
  components: {
    VueJsonPrettyWrapper
  },

  props: {
    terminal: Object
  }
}
</script>



// WEBPACK FOOTER //
// src/components/terminal/components/AccountTerminalDebug.vue